/**
 * bogo-product-form.js
 *
 * Loaded only by snippets/bogo-buy-buttons.liquid.
 * Defines the <bogo-product-form> custom element which handles ATC and
 * redirects to the collection URL matching the selected variant's size,
 * instead of opening the slide cart.
 *
 * The redirect map (variantId → URL) is embedded in the page as an inline
 * <script type="application/json" data-bogo-redirect-map> element.
 */
if (!customElements.get("bogo-product-form")) {
  customElements.define(
    "bogo-product-form",
    class BogoProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === "true";

        subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      }

      onVariantChange({ data }) {
        if (data.sectionId !== this.dataset.sectionId) return;

        const newButton = data.html.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
        if (!newButton || !this.submitButton) return;

        this.submitButton.innerHTML = newButton.innerHTML;
        if (newButton.hasAttribute('disabled')) {
          this.submitButton.setAttribute('disabled', 'disabled');
        } else {
          this.submitButton.removeAttribute('disabled');
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }

      getRedirectUrl(variantId) {
        const mapEl = this.querySelector(
          'script[type="application/json"][data-bogo-redirect-map]',
        );
        if (!mapEl) return null;
        try {
          const map = JSON.parse(mapEl.textContent);
          return map[String(variantId)] || null;
        } catch (e) {
          return null;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", "true");
        this.submitButton.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.errors || response.description);
              this.submitButton.removeAttribute("aria-disabled");
              this.submitButton.classList.remove("loading");
              return;
            }

            const variantId = formData.get("id");
            const redirectUrl = this.getRedirectUrl(variantId);

            window.location.href = redirectUrl
              ? redirectUrl + '?bogo_offer=true'
              : theme.routes.cart_url;
          })
          .catch((e) => {
            console.error("[bogo-product-form]", e);
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("loading");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
